<template>
  <main class="main page-inside static-page">
    <div class="main-wrapper">
      <section class="static-page__section">
        <div class="static-page__container">
          <transition name="static-content">
            <article v-if="$parent.textPageTitle" class="static-document">
              <div
                class="static-document__content"
                v-html="$parent.textPageContent"
              ></div>
            </article>
          </transition>

          <div
            v-if="!$parent.textPageTitle"
            class="static-document static-document_loading"
          >
            <div class="static-loading">
              <div
                class="static-loading__line static-loading__line_title"
              ></div>

              <div class="static-loading__line"></div>
              <div class="static-loading__line"></div>

              <div
                class="static-loading__line static-loading__line_short"
              ></div>

              <div class="static-loading__space"></div>

              <div
                class="static-loading__line static-loading__line_heading"
              ></div>

              <div class="static-loading__line"></div>
              <div class="static-loading__line"></div>

              <div
                class="static-loading__line static-loading__line_short"
              ></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
export default {
  name: 'TextPage',
  props: [],
  components: {},

  data: function () {
    return {}
  },

  mounted() {
    this.loadPage()
  },

  watch: {
    '$route.params.id': {
      handler() {
        this.loadPage()
      },
    },
  },

  methods: {
    loadPage() {
      const id = this.$route.params.id

      if (!id) {
        console.error('Missing static page route parameter')
        return
      }

      this.$parent.getTextPageContent(id)
    },
  },
}
</script>

<style scoped lang="scss">
.static-page {
  position: relative;
  min-height: 50vh;

  background: radial-gradient(
      circle at 70% 0%,
      rgba(33, 193, 126, 0.04),
      transparent 35%
    ),
    var(--white-woodsmoke);
}

.static-page::before {
  content: '';
  position: absolute;
  inset: 0 0 auto;
  height: 1px;

  background: var(--outer-space);
  pointer-events: none;
}

.static-page__container {
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
}

/* Hero */

.static-page__hero {
  position: relative;
  padding: 58px 16px 25px;
  overflow: hidden;
}

.static-page__glow {
  position: absolute;
  top: -270px;
  left: 50%;
  width: 780px;
  height: 500px;

  transform: translateX(-5%);

  background: radial-gradient(
    circle,
    rgba(33, 193, 126, 0.055),
    transparent 70%
  );

  pointer-events: none;
}

.static-page__hero .static-page__container {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 18px;
}

.static-page__back {
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
  padding: 0;

  background: var(--heavy-metal);
  border: 1px solid var(--outer-space);
  border-radius: 9px;

  box-shadow: inset 2px 2px 0 rgba(255, 255, 255, 0.025),
    inset -2px -2px 0 rgba(0, 0, 0, 0.24);

  transition: background-color 0.2s ease, border-color 0.2s ease,
    transform 0.2s ease;

  @media (any-hover: hover) {
    &:hover {
      background: var(--outer-space);
      border-color: var(--31);
      transform: translateX(-3px);
    }
  }
}

.static-page__back-icon {
  display: block;
  width: 17px;
  height: 17px;
}

.static-page__heading {
  min-width: 0;
}

.static-page__subtitle {
  margin-bottom: 12px;

  font-family: var(--font-3);
  font-size: 10px;
  font-weight: 700;
  line-height: 13px;
  letter-spacing: 0.04em;
  text-transform: uppercase;

  color: var(--mountain-meadow);

  &::before {
    content: '//';
    margin-right: 8px;
  }
}

.static-page__title {
  margin: 0;

  font-family: var(--font-2);
  font-size: 34px;
  font-weight: 700;
  line-height: 43px;

  color: var(--gray-nurse);
  overflow-wrap: anywhere;
}

.static-page__title::v-deep * {
  margin: 0;
  font: inherit;
  color: inherit;
}

.static-page__description {
  max-width: 720px;
  margin: 11px 0 0;

  font-family: var(--font-1);
  font-size: 13px;
  font-weight: 400;
  line-height: 21px;

  color: var(--mantle);
}

.static-page__title-placeholder {
  width: min(420px, 80%);
  height: 40px;
  border-radius: 6px;

  background: linear-gradient(
    90deg,
    var(--heavy-metal) 25%,
    var(--outer-space) 50%,
    var(--heavy-metal) 75%
  );

  background-size: 200% 100%;
  animation: static-loading 1.4s linear infinite;
}

/* Content */

.static-page__section {
  padding: 10px 16px 110px;
}

.static-document {
  position: relative;
  overflow: hidden;
  padding: 30px 34px 38px;

  background: linear-gradient(
      145deg,
      rgba(33, 193, 126, 0.018),
      transparent 46%
    ),
    var(--bunker-86);

  border: 1px solid var(--outer-space);
  border-radius: 10px;

  box-shadow: 6px 6px 0 #0c0f13, inset 2px 2px 0 rgba(255, 255, 255, 0.018),
    inset -2px -2px 0 rgba(0, 0, 0, 0.18);
}

.static-document__header {
  display: flex;
  align-items: center;
  margin-bottom: 27px;
  padding-bottom: 18px;

  border-bottom: 1px solid var(--outer-space);
}

.static-document__label {
  display: inline-flex;
  align-items: center;
  gap: 8px;

  font-family: var(--font-1);
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;

  color: var(--mountain-meadow);

  svg {
    width: 17px;
    height: 17px;
  }
}

/*
 * Content from v-html needs ::v-deep because it does not
 * automatically receive the component scoped attribute.
 */

.static-document__content {
  font-family: var(--font-1);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.75;

  color: var(--mantle);
  overflow-wrap: anywhere;
}

.static-document__content::v-deep h1,
.static-document__content::v-deep h2,
.static-document__content::v-deep h3,
.static-document__content::v-deep h4,
.static-document__content::v-deep h5,
.static-document__content::v-deep h6 {
  margin: 32px 0 13px;

  font-family: var(--font-2);
  font-weight: 700;

  color: var(--gray-nurse);
}

.static-document__content::v-deep h1:first-child,
.static-document__content::v-deep h2:first-child,
.static-document__content::v-deep h3:first-child {
  margin-top: 0;
}

.static-document__content::v-deep h1 {
  font-size: 27px;
  line-height: 35px;
}

.static-document__content::v-deep h2 {
  font-size: 21px;
  line-height: 29px;
}

.static-document__content::v-deep h3 {
  font-size: 17px;
  line-height: 24px;
}

.static-document__content::v-deep h4,
.static-document__content::v-deep h5,
.static-document__content::v-deep h6 {
  font-size: 15px;
  line-height: 22px;
}

.static-document__content::v-deep p {
  margin: 0 0 16px;
}

.static-document__content::v-deep p:last-child {
  margin-bottom: 0;
}

.static-document__content::v-deep strong,
.static-document__content::v-deep b {
  font-weight: 700;
  color: var(--gray-nurse);
}

.static-document__content::v-deep a {
  color: var(--mountain-meadow);

  text-decoration: underline;
  text-decoration-color: rgba(33, 193, 126, 0.35);
  text-underline-offset: 3px;

  transition: color 0.2s ease, text-decoration-color 0.2s ease;
}

.static-document__content::v-deep a:hover {
  color: var(--gray-nurse);
  text-decoration-color: var(--gray-nurse);
}

.static-document__content::v-deep ul,
.static-document__content::v-deep ol {
  margin: 16px 0;
  padding-left: 25px;
}

.static-document__content::v-deep li {
  margin: 8px 0;
  padding-left: 4px;
}

.static-document__content::v-deep li::marker {
  color: var(--mountain-meadow);
}

.static-document__content::v-deep blockquote {
  margin: 22px 0;
  padding: 16px 18px;

  color: var(--pewter);
  background: rgba(33, 193, 126, 0.045);
  border-left: 3px solid var(--mountain-meadow);
  border-radius: 0 7px 7px 0;
}

.static-document__content::v-deep hr {
  height: 1px;
  margin: 28px 0;

  background: var(--outer-space);
  border: 0;
}

.static-document__content::v-deep table {
  width: 100%;
  margin: 22px 0;

  border-collapse: collapse;
  border-spacing: 0;
}

.static-document__content::v-deep th,
.static-document__content::v-deep td {
  padding: 12px 14px;

  text-align: left;
  vertical-align: top;

  border: 1px solid var(--outer-space);
}

.static-document__content::v-deep th {
  font-weight: 600;
  color: var(--gray-nurse);
  background: rgba(7, 13, 10, 0.55);
}

.static-document__content::v-deep td {
  color: var(--mantle);
  background: rgba(11, 18, 14, 0.3);
}

.static-document__content::v-deep img {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 22px auto;

  border: 1px solid var(--outer-space);
  border-radius: 7px;
}

.static-document__content::v-deep code {
  padding: 2px 6px;

  font-family: monospace;
  font-size: 0.92em;

  color: var(--mountain-meadow);
  background: var(--heavy-metal);
  border: 1px solid var(--outer-space);
  border-radius: 4px;
}

.static-document__content::v-deep pre {
  max-width: 100%;
  margin: 20px 0;
  padding: 16px;

  overflow-x: auto;

  font-family: monospace;
  color: var(--pewter);

  background: rgba(7, 13, 10, 0.72);
  border: 1px solid var(--outer-space);
  border-radius: 7px;
}

.static-document__content::v-deep pre code {
  padding: 0;

  color: inherit;
  background: none;
  border: 0;
}

.static-document__content::v-deep span {
  overflow-wrap: anywhere;
}

/* Loading */

.static-document_loading {
  min-height: 380px;
}

.static-loading {
  display: flex;
  flex-direction: column;
  gap: 13px;
}

.static-loading__line {
  width: 100%;
  height: 13px;
  border-radius: 4px;

  background: linear-gradient(
    90deg,
    var(--heavy-metal) 25%,
    var(--outer-space) 50%,
    var(--heavy-metal) 75%
  );

  background-size: 200% 100%;
  animation: static-loading 1.4s linear infinite;

  &_title {
    width: 48%;
    height: 22px;
    margin-bottom: 8px;
  }

  &_heading {
    width: 36%;
    height: 18px;
    margin-bottom: 5px;
  }

  &_short {
    width: 67%;
  }
}

.static-loading__space {
  height: 16px;
}

@keyframes static-loading {
  from {
    background-position: 200% 0;
  }

  to {
    background-position: -200% 0;
  }
}

/* Transition */

.static-content-enter-active,
.static-content-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.static-content-enter,
.static-content-leave-to {
  opacity: 0;
  transform: translateY(6px);
}

/* Tablet */

@media (max-width: 991.98px) {
  .static-page__container {
    max-width: 820px;
  }

  .static-page__hero {
    padding-top: 46px;
  }
}

/* Mobile */

@media (max-width: 767.98px) {
  .static-page__hero {
    padding: 29px 16px 18px;
  }

  .static-page__hero .static-page__container {
    gap: 13px;
  }

  .static-page__back {
    flex-basis: 36px;
    width: 36px;
    height: 36px;
  }

  .static-page__back-icon {
    width: 15px;
    height: 15px;
  }

  .static-page__subtitle {
    margin-bottom: 9px;
    font-size: 9px;
  }

  .static-page__title {
    font-size: 26px;
    line-height: 34px;
  }

  .static-page__description {
    margin-top: 8px;
    font-size: 12px;
    line-height: 19px;
  }

  .static-page__section {
    padding: 8px 0px 25px;
  }

  .static-document {
    padding: 23px 20px 28px;
    border-radius: 8px;
  }

  .static-document__header {
    margin-bottom: 22px;
    padding-bottom: 15px;
  }

  .static-document__content {
    font-size: 13px;
    line-height: 1.7;
  }

  .static-document__content::v-deep h1 {
    font-size: 23px;
    line-height: 31px;
  }

  .static-document__content::v-deep h2 {
    font-size: 19px;
    line-height: 27px;
  }

  .static-document__content::v-deep h3 {
    font-size: 16px;
    line-height: 23px;
  }

  .static-document__content::v-deep table {
    display: block;
    overflow-x: auto;
  }
}

@media (max-width: 480px) {
  .static-page__hero .static-page__container {
    display: block;
  }

  .static-page__back {
    margin-bottom: 17px;
  }

  .static-document {
    padding: 19px 16px 23px;

    box-shadow: 4px 4px 0 #0c0f13, inset 2px 2px 0 rgba(255, 255, 255, 0.018),
      inset -2px -2px 0 rgba(0, 0, 0, 0.18);
  }
}
</style>
